<template>
  <data-table
    :data="items"
    :headers="headers"
    :hide-table-bottom="true"
    :hide-edit="true"
    :hide-delete="true"
    :loading="loading"
    :bg-extension="'#dee2e6'"
  />
</template>

<script>
import DataTableCpfCnpjColumnVue from '@/app/arch/components/data-table/DataTableColumns/DataTableCpfCnpjColumn.vue';
import DataTableCurrencyColumnVue from '@/app/arch/components/data-table/DataTableColumns/DataTableCurrencyColumn.vue';
import DataTable from '@/app/arch/components/data-table/DataTable.vue';
import DataTableDateColumnVue from '@/app/arch/components/data-table/DataTableColumns/DataTableDateColumn.vue';
import ConciliationPendingStatusColumnVue from './ConciliationPendingStatusColumn.vue';

export default {
  name: 'ConciliationPendingTransferList',
  components: { DataTable },
  props: {
    row: {
      type: Object,
      default() {
        return {
          pendingTransfers: [],
        };
      },
    },
    loading: {
      type: Boolean,
    },
  },
  data: () => ({
    headers: [
      {
        text: 'Nome',
        value: 'clientName',
      },
      {
        text: 'Documento',
        value: 'clientDocument',
        component: DataTableCpfCnpjColumnVue,
      },
      {
        text: 'Banco',
        value: 'bankName',
      },
      {
        text: 'Agência',
        value: 'agency',
      },
      {
        text: 'Conta',
        value: 'account',
      },
      {
        text: 'Valor',
        value: 'value',
        component: DataTableCurrencyColumnVue,
      },
      {
        text: 'Situação',
        value: 'situation',
        component: ConciliationPendingStatusColumnVue,
      },
      {
        text: 'Data da pendência',
        value: 'createdAt',
        component: DataTableDateColumnVue,
      },
    ],
  }),
  computed: {
    items() {
      return this.row.pendingTransfers;
    },
  },
};
</script>
